import PropTypes from 'prop-types';
import React from 'react';
import styled from 'react-emotion';

import DeleteModal from '../../../../../components/Modals/DeleteModal/DeleteModal';
import ErrorMessage from '../../../../../components/Messages/ErrorMessage';
import Style from '../../../../../styles/common';
import SubmitButton from '../../../../../components/Buttons/SubmitButton';
import TextButton from '../../../../../components/Buttons/TextButton';
import { TIER } from '../../../../../components/Buttons/constants';

const Container = styled('div')`
  align-items: center;
  background-color: ${Style.color.FORM_FOOTER.BACKGROUND};
  bottom: 0;
  display: flex;
  height: ${Style.MEASUREMENT.EVENT_FORM.FOOTER.HEIGHT};
  left: 0;
  position: absolute;
  padding: 0 ${Style.SPACING.XXXL};
  width: 100%;
`;

const Content = styled('div')`
  display: flex;
  justify-content: space-between;
  flex: 1;
`;

const Buttons = styled('div')`
  align-items: center;
  display: flex;
`;

const StyledTextButton = styled(TextButton)`
  margin-right: ${Style.SPACING.XS};
`;

class ManageEventsBodyFormFooter extends React.Component {
  static propTypes = {
    deleteActiveEvent: PropTypes.func.isRequired,
    eventTitle: PropTypes.string.isRequired,
    hasFailed: PropTypes.bool,
    isSubmitting: PropTypes.bool,
    isSuccessful: PropTypes.bool,
    submitFailed: PropTypes.bool,
  };

  static defaultProps = {
    hasFailed: false,
    isSubmitting: false,
    isSuccessful: false,
    submitFailed: false,
  };

  state = {
    isModalVisible: false,
  };

  render() {
    return (
      <Container>
        <Content>
          {this.errorMessage}
          <Buttons>
            <StyledTextButton
              icon="trash-alt"
              onClick={this.onModalOpen}
              tier={TIER.SECONDARY}
            >
              Delete
            </StyledTextButton>
            <SubmitButton
              disabled={this.props.isSubmitting}
              loading={this.props.isSubmitting}
            >
              Update event
            </SubmitButton>
          </Buttons>
        </Content>
        <DeleteModal
          eventTitle={this.props.eventTitle}
          onClose={this.onModalClose}
          onDelete={this.onDelete}
          visible={this.state.isModalVisible}
        />
      </Container>
    );
  }

  onModalOpen = () => {
    this.setState({ isModalVisible: true });
  };

  onModalClose = () => {
    this.setState({ isModalVisible: false });
  };

  onDelete = () => {
    this.props.deleteActiveEvent();
    this.onModalClose();
  };

  get errorMessage() {
    let message = null;
    if (this.props.submitFailed) {
      message = (
        <ErrorMessage shouldAnimate={true}>
          Failed to update event
        </ErrorMessage>
      );
    }
    return (
      <div>{message}</div>
    );
  }
}

export default ManageEventsBodyFormFooter;



// WEBPACK FOOTER //
// ./src/views/ManageEvents/ManageEventsBody/ManageEventsBodyForm/ManageEventsBodyFormFooter/ManageEventsBodyFormFooter.js